import React, { useState, useEffect } from "react";
import {
  Dialog,
  DialogTitle,
  DialogContent,
  DialogActions,
  FormControl,
  InputLabel,
  Select,
  MenuItem,
  Button,
} from "@mui/material";
import api from "../../globals/axios";
import { useTranslation } from "react-i18next";
import { useAlert } from "../../components/Alert";

const CropSelectionPopUp = ({ open, onClose, prediction_id }) => {
  const [crops, setCrops] = useState([]);
  const [selectedCrop, setSelectedCrop] = useState("");
  const [loading, setLoading] = useState(false);
  const { t } = useTranslation();
  const { showAlert } = useAlert();

  useEffect(() => {
    const fetchCrops = async () => {
      try {
        const response = await api.get("/farmer/crops/");
        setCrops(response.data);
      } catch (error) {
        console.error("Error fetching crops:", error);
        showAlert("error", "Failed to fetch crops");
      }
    };
    fetchCrops();
  }, []);

  const handleSubmit = async () => {
    try {
      setLoading(true);
      await api.patch("/farmer/update-ai-prediction-history-crop/", {
        prediction_id: prediction_id,
        crop_id: selectedCrop,
      });
      onClose(true);
      showAlert("success", "Crop updated successfully");
    } catch (error) {
      console.error("Error updating crop:", error);
      showAlert("error", "Failed to update crop");
    } finally {
      setLoading(false);
    }
  };

  return (
    <Dialog fullWidth open={open} onClose={() => onClose(false)}>
      <DialogTitle>{t("Select Crop")}</DialogTitle>
      <DialogContent>
        <FormControl fullWidth sx={{ mt: 2 }}>
          <InputLabel>{t("Crop")}</InputLabel>
          <Select
            value={selectedCrop}
            label={t("Crop")}
            onChange={(e) => setSelectedCrop(e.target.value)}
          >
            {loading ? (
              <MenuItem disabled>{t("Loading")}...</MenuItem>
            ) : crops.length > 0 ? (
              crops.map((crop) => (
                <MenuItem key={crop.id} value={crop.id}>
                  {crop.farmland?.farm_name} - {crop.commodity?.name}
                </MenuItem>
              ))
            ) : (
              <MenuItem disabled>{t("No crops available")}</MenuItem>
            )}
          </Select>
        </FormControl>
      </DialogContent>
      <DialogActions>
        <Button onClick={() => onClose(false)} color="error">
          {t("Close")}
        </Button>
        <Button
          onClick={handleSubmit}
          color="primary"
          disabled={!selectedCrop || loading}
        >
          {loading ? `${t("Submitting")}...` : t("Submit")}
        </Button>
      </DialogActions>
    </Dialog>
  );
};

export default CropSelectionPopUp;
